__turbopack_context__.v({
  "className": "oswald_86459cbe-module__HR77oa__className",
  "variable": "oswald_86459cbe-module__HR77oa__variable",
});
